export const defaultTableDateFirms = () => {
  return {
    items: [],
    fields: [
      {
        field: "account_id",
        name: "Cuenta",
        format: "text",
        style: { width: 350, short: true }
      },
      {
        field: "firm_date_account",
        name: "Fecha Firme Cuenta"
      },
      {
        field: "observations",
        name: "Observaciones",
        format: "text",
        style: { width: 50 }
      },
      {
        field: "firm_date_modification",
        name: "Usuario ult mod",
        format: "text",
        style: { width: 150 }
      },
      {
        field: "actions",
        name: "Opciones",
        format: "text",
        style: { width: 100, short: true }
      }
    ],
    pagination: "",
    params: {
      perPage: 100,
      filterText: "",
      currentPage: 1,
      page: 1,
      pagination: true
    }
  };
};

export default {
  tableDateFirms: defaultTableDateFirms(),
  dateFirm: {
      'firm_date_general' : null
  },
  action: "create",
  errorForm: false,
  firm_date_modification:null,
};



// WEBPACK FOOTER //
// ./src/modules/dateFirm/state.js